module.exports = __webpack_public_path__ + "img/step1-b.503cb9bd.png";